import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import { CuadroCard } from 'components/Card/CuadroCard';
import Loader from 'components/Loader';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getSeriesState } from 'selectors/series';
import { getCuadrosData } from 'selectors/cuadros';
import { getSeries } from 'store/series/actions';
import { getCuadros } from 'store/cuadros/actions';
import {
  TopBar,
  BackButton,
  SerieTitleWrapper,
  SerieTitle,
  SerieTitleAccent,
  SerieGrid,
} from './styled';

export const SerieDetailScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { seriesState, cuadrosData } = useAppSelector(state => ({
    seriesState: getSeriesState(state),
    cuadrosData: getCuadrosData(state),
  }));

  useEffect(() => {
    if (!seriesState.data) dispatch(getSeries());
    if (!cuadrosData) dispatch(getCuadros());
  }, []);

  const serie = seriesState.data?.find(s => s.id === Number(id));
  const serieCuadros = (cuadrosData || [])
    .filter(c => c.id_serie === Number(id))
    .sort((a, b) => a.order - b.order);

  return (
    <>
      {(seriesState.isLoading || !cuadrosData) && <Loader type="dots" />}
      <Header />
      <TopBar>
        <BackButton onClick={() => navigate('/art')}>← Volver</BackButton>
      </TopBar>
      <SerieTitleWrapper>
        <SerieTitle>{serie?.title || ''}</SerieTitle>
        <SerieTitleAccent />
      </SerieTitleWrapper>
      <SerieGrid>
        {serieCuadros.map(cuadro => (
          <CuadroCard key={cuadro.id} cuadro={cuadro} />
        ))}
      </SerieGrid>
      <Footer />
    </>
  );
};
